// BFF: ● onboarding — bffCrmOnboarding.
export { default } from './PatientDetailOnboarding'
export { default as OnboardingRelatedView } from './OnboardingRelatedView'
